import {Component, inject, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {ActivatedRoute, Router, RouterModule} from '@angular/router';
import { Title } from '@angular/platform-browser';
import { ENVIRONMENT, User } from '@company-box/models';
import { BoxService, AlertService, UserService } from '@company-box/services';
import { LoadingModalComponent } from '@company-box/utils';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NGXLogger } from 'ngx-logger';
import { CommonModule } from '@angular/common';
import { NotFoundModalComponent } from '../../features/layouts/not-found-modal/not-found-modal.component';
import { Subscription } from 'rxjs';
import { LocalStorageService } from '../../../../../libs/services/src/lib/localstorage.service';
import { NavigationService } from '../../services/navigation.service';

declare var window: any;


@Component({
  selector: 'app-box-style',
  templateUrl: './box-style.component.html',
  styleUrls: ['./box-style.component.scss'],
  imports: [
    RouterModule,
    CommonModule,
    LoadingModalComponent,
    NotFoundModalComponent
  ]
})
export class BoxStyleComponent implements OnInit, OnDestroy {

  @ViewChild('notFoundModal', { static: false }) notFoundModal!: TemplateRef<any>;

  private modal: BsModalRef | undefined;
  private subscription = new Subscription();

  categoryCode!: string;
  shownCategory = 0;
  public date = new Date();
  private user: User | undefined;
  subcategories: any[] = [];
  subcategoryDescriptions = ['Make an impact with custom printed mailing boxes.', 'Redefine what\'s possible with custom printed shipping boxes.', 'Drive point-of-purchase sales through custom packaging.', 'Showcase your brand at any event.'];
  public failedcategories = false;
  public uploadDesign = false;
  public pageLoading: boolean = false;
  private titleService = inject(Title);
  private environment = inject(ENVIRONMENT);

  constructor(
    private boxService: BoxService,
    private route: ActivatedRoute,
    private alertSvc: AlertService,
    private userService: UserService,
    private logger: NGXLogger,
    private bsModalService: BsModalService,
    private navigationService: NavigationService,
    private localStorageService: LocalStorageService,
    private router: Router) {
  }

  async ngOnInit() {
    this.pageLoading = true;
    this.localStorageService.clear();
    const params = this.route.snapshot.params;
    this.categoryCode = params['category']??'';
    this.uploadDesign = params["uploadDesign"] === "true";
    window.scroll(0, 0);
    this.navigationService.setCategory(this.categoryCode);
    this.getSubcategories();
    await this.userService.getCurrentUser().then(res => this.user = res);
    if (window.loyaltylion) {
      window.loyaltylion.authenticateCustomer({
        customer: {id: this.user?.shopifyId, email: this.user?.username},
        auth: {date: this.date.toISOString(), token: this.getAuthToken()}
      });
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  getAuthToken() {
    const date = this.date.toISOString();
    const secret = 'b3456ad863ff28b11560dce3d09e5ee0';
    const authToken = CryptoJS.SHA1(this.user?.shopifyId + date + this.user?.username + secret);

    return authToken.toString();
  }
  goBack() {
    this.router.navigate(['/box-category'], {
      fragment: `upload=${this.uploadDesign}`
    });
  }

  getSubcategories() {
    this.boxService.getCategory(this.categoryCode, true).then(category => {
      this.failedcategories = false;
      if (category.name) {
        this.titleService.setTitle(`${category.name} | Select a Style | ${this.environment.config.title}`);
      }
      if (category.subcategories.length === 1) {
        this.router.navigate(['/box-options', this.categoryCode, category.subcategories[0].code, this.uploadDesign]);
      } else {
        category.subcategories.forEach(subcategory => {
          this.subcategories.push(subcategory);
        });
      }
    }, reason => {
      this.showModal(this.notFoundModal);
      this.alertSvc.showError({ msg: 'Unable to load box styles' });
      this.logger.error(reason);
      this.failedcategories = true;
    })
    .finally(() => this.pageLoading = false);
  }

  showModal(template: TemplateRef<any>) {
    this.modal = this.bsModalService.show(template);
  }
  hide() {
    this.modal?.hide();
  }
  public trackByFn(_index: number, item: any) {
    if (!item) {
      return null;
    } else {
      return item.id;
    }
  }

  getPlainName(subcategory: any): string {
    return (subcategory?.name ?? '').replace(/<[^>]*>/g, '');
  }
  // the below all deal with the carousel for the mobile view
  getDefaultPicture(subcategory: any) {
    if (subcategory.images.length > 0) {
      for (const image of subcategory.images) {
        if (image.default) {
          return image.location;
        }
      }
      return subcategory.images[0].location;
    }
  }

  getGIF(subcategory: any) {
    for (const image of subcategory.images) {
      if (image.hover === 'true') {
        return image.location;
      }
    }
    return this.getDefaultPicture(subcategory);
  }

  showGIF(div: any, subcategory: any) {
    div.style = 'background: url(' + this.getGIF(subcategory) + ');';
  }

  showStaticPicture(div: any, subcategory: any) {
    div.style = 'background: url(' + this.getDefaultPicture(subcategory) + ');';
  }

  previousCategory() {
    if (this.shownCategory !== 0) {
      this.shownCategory = (this.shownCategory - 1);
    }
  }

  nextCategory() {
    if (this.shownCategory !== (this.subcategories.length - 1)) {
      this.shownCategory = (this.shownCategory + 1);
    }
  }

}
